import type { Placement } from '@popperjs/core'
import type { TooltipOptions } from './lib'

const [skidding, distance] = [0, 10]

export const defaultOptions = Object.freeze<TooltipOptions>({
  label: '',
  offset: [skidding, distance],
  placement: 'top',
  show: true,
  textAlign: 'center',
  isFullLength: false,
  zIndex: 200,
  withinTarget: false,
})
export const availablePositions: Placement[] = [
  'top',
  'bottom',
  'left',
  'right',
]
export const textAlignments = ['left', 'center', 'end']
